import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject, Observable} from 'rxjs/Rx';
import {environment} from '../../environments/environment';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import {MessagingService} from './messaging.service';

@Injectable()
export class UserService {

  private loggedIn = false;
  private _userUrl: string = environment.baseUrl + '/users';
  private _apiUserUrl: string = environment.baseUrl + '/apiusers';


  // headers
  public headers: Object;


  // observable variables
  public newSearchSubject: Subject<any> = new BehaviorSubject<any>(null);
  public newStatusSubject: Subject<any> = new BehaviorSubject<any>(null);
  public modalPopupSubject: Subject<any> = new BehaviorSubject<any>(null);
  public newCreatedUserSubject: Subject<any> = new BehaviorSubject<any>(null);
  public userListSubject: Subject<any> = new BehaviorSubject<any>(null);
  public currentUserSubject = new BehaviorSubject<any>(null);

  // user watcher
  public updatedUserSubject: Subject<any> = new BehaviorSubject<any>(null);
  public currentUser;

  public loggedFullIn = false;

  constructor(private http: Http, private msgService: MessagingService) {
    this.loggedIn = !!localStorage.getItem('auth_token');
    this.loggedFullIn = !!localStorage.getItem('code_token');
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.currentUserSubject.next(this.currentUser);
    this.currentUserSubject.subscribe((v) => {
      this.currentUser = v;
      if (v !== null) localStorage.setItem('current_user', JSON.stringify(v));
    });
  }

  buildHeaders(type: string) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    switch (type) {
      case 'code_token':
        headers.append('Authorization', localStorage.getItem('code_token'));
        break
      default:
        break;
    }
    return headers;
  }

  login(email, password) {
    const headers = this.buildHeaders(null);
    const time = new Date();

    return this.http
      .post(
        this._userUrl + '/login',
        JSON.stringify({email, password}),
        {headers}
      )
      .map(res => res.json())
      .map((res) => {
        if (res.token != null) {
          localStorage.setItem('auth_token', JSON.stringify(res.token));
          localStorage.setItem('logout_timeout', JSON.stringify(time.getTime() + 60 * 60 * 1000)); // 1 hour
          this.loggedIn = true;
        }

        return this.loggedIn;
      })
      .catch((error: Response) => {
        // this.msgService.sendMessage(error); // don't double error message
        return Observable.throw(error);
      });
  }

  logout() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('code_token');
    localStorage.removeItem('current_user');
    localStorage.removeItem('logout_timeout');
    this.loggedIn = false;
    this.loggedFullIn = false;
    location.reload();
  }

  isLoggedIn() {
    return this.loggedIn;
  }

  isLoggedFullIn() {
    return !!localStorage.getItem('code_token');
  }

  forgotPassword(email) {
    const headers = this.buildHeaders(null);

    return this.http
      .post(
        this._userUrl + '/forgotpassword',
        JSON.stringify({email}),
        {headers}
      )
      .catch((error: Response) => {
        // this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  resetPassword(password, password_confirm, token) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', token);

    return this.http
      .post(
        this._userUrl + '/validate',
        JSON.stringify({password, password_confirm}),
        {headers}
      )
      .map(res => res.json())
      .map((res) => {
        return true;
      })
      .catch((error: Response) => {
        //this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  updatePassword(passwords) {
    const headers = this.buildHeaders('code_token');

    return this.http
      .post(
        this._userUrl + '/updatepassword',
        JSON.stringify(passwords),
        {headers}
      )
      .map(res => res.json())
      .map((res) => {
        localStorage.setItem('auth_token', res.token);
        return true;
      })
      .catch((error: Response) => {
        return Observable.throw(error);
      });

  }

  verifyCode(code, token) {
    const headers = this.buildHeaders(null);
    headers.append('Authorization', token);

    return this.http
      .post(
        this._userUrl + '/validate',
        JSON.stringify({code}),
        {headers}
      )
      .map(res => res.json())
      .map((res) => {

        // calculate curret user role
        // superadmin
        if (res.detail.level === 1 && res.detail.organization_id.toLowerCase() === 'streamuk') {
          res.detail.role = 'superadmin';
        }
        // admin
        if (res.detail.level === 1 && res.detail.organization_id.toLowerCase() === 'bbc') {
          res.detail.role = 'admin';
        }
        // user
        if (res.detail.level === 2) {
          res.detail.role = 'user';
        }
        localStorage.setItem('code_token', res.token);
        this.currentUserSubject.next(res.detail);
        this.loggedFullIn = true;
        return true;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  // CRUD
  getUsers() {
    const headers = this.buildHeaders('code_token');

    return this.http
      .get(
        this._userUrl,
        {headers})
      .map(res => res.json())
      .map((res) => {
        this.userListSubject.next(res);
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  createUser(body: Object, request, userID): Observable<any> {
    const headers = this.buildHeaders('code_token');

    return this.http
      .post(
        this._userUrl,
        JSON.stringify(body),
        {headers})
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .map((res) => {
        this.newCreatedUserSubject.next(res);
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });

  }

  deleteUser(user) {
    const headers = this.buildHeaders('code_token');

    return this.http
      .delete(
        this._userUrl + '/' + user.id,
        {headers}
      )
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  setUpdatableUser(user) {
    this.updatedUserSubject.next(user);
  }

  updateUser(user, request, userID) {
    const headers = this.buildHeaders('code_token');
    user.mobile_number = user.mobile_number.toString();

    return this.http
      .put(this._userUrl + '/' + userID,
        JSON.stringify(user),
        {headers})

      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  // disable/enable user
  ableUser(user, able) {
    const headers = this.buildHeaders('code_token');
    let url = this._userUrl;
    if (!user.level) {
      url = this._apiUserUrl;
    }
    return this.http
      .get(
        url + '/' + user.id + '/' + able,
        {headers})
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  setSearchValue(val) {
    if (typeof(val) === 'object') {
      this.newSearchSubject.next(val.target.value);
    } else if (val === true || val === false) {
      this.newStatusSubject.next(val);
    } else {
      this.newStatusSubject.next('');
    }
  }

  setPopupObject(val) {
    this.modalPopupSubject.next(val);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/user.service.ts